
function ReformatDate(date:any) {
    return (date.substr(0,10));
  }
  
  export default ReformatDate;